import {
  Box,
  Flex,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AdminNavbarLinks from "./AdminNavbarLinks";
import textura from '../../assets/img/textura_4.jpg'; // Importando a textura

const pageTitles = {
  '/admin/Dashboard': 'Percentual de respostas',
  '/admin/repos': 'Bibliotecas de Áudio',
  '/admin/audit_cadastro': 'Cadastrar fichas',
  '/admin/audit_jobs': 'Processamento Automático',
  '/admin/transcripts': 'Transcrições',
  '/admin/extracoes': 'Relatórios',
  '/admin/results': 'Buscar resultados',
  '/admin/relatorios': 'Monitoramento',
  '/admin/audios': 'Áudios',
  '/admin/campanhas': 'Adicionar campanhas',
  '/admin/operacoes': 'Adicionar operações',
  '/admin/usuarios': 'Adicionar usuários',
  '/admin/logs': 'Logs do usuário',
};

export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);
  const [title, setTitle] = useState("")

  const {
    variant,
    children,
    fixed,
    secondary,
    brandText,
    onOpen,
    ...rest
  } = props;

  if (props.fixed === true)
    if (scrolled === true) {
      navbarPosition = "fixed";
      navbarShadow = useColorModeValue(
        "0px 7px 23px rgba(0, 0, 0, 0.05)",
        "none"
      );
      navbarBg = useColorModeValue(
        "linear-gradient(112.83deg, rgba(255, 255, 255, 0.82) 0%, rgba(255, 255, 255, 0.8) 110.84%)",
        "linear-gradient(112.83deg, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0) 110.84%)"
      );
      navbarBorder = useColorModeValue("#FFFFFF", "rgba(255, 255, 255, 0.31)");
      navbarFilter = useColorModeValue(
        "none",
        "drop-shadow(0px 7px 23px rgba(0, 0, 0, 0.05))"
      );
    }
  if (props.secondary) {
    navbarBackdrop = "none";
    navbarPosition = "absolute";
    mainText = "white";
    secondaryMargin = "22px";
    paddingX = "30px";
  }
  const changeNavbar = () => {
    if (window.scrollY > 1) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  window.addEventListener("scroll", changeNavbar);

  const location = useLocation();

  useEffect(() => {
    setTitle(pageTitles[location.pathname] || '')
  }, [location]);

  return (
    <Flex
      bg={useColorModeValue('brand.600', 'gray.800')}
      padding={2} //altura nav bar
      paddingX={8} //distacoa da margim
      position="relative"
      zIndex={1} // Garante que os elementos estejam acima da textura
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        zIndex={-1} // A textura fica por trás do conteúdo
        backgroundImage={`url(${textura})`}
        backgroundSize="cover"
        backgroundBlendMode="overlay"
        opacity={0.2} // A opacidade aplicada apenas à textura
      />
      <Flex
        w="100%"
        flexDirection={{
          sm: "column",
          md: "row",
        }}
        alignItems={{ xl: "center" }}
        justifyContent={'space-between'}
      >
        <Text
          fontSize={'3xl'}  // Tamanho da fonte permanece
          fontWeight={'bold'}
          color={'white'}
        >
          {title}
        </Text>

        <Box ms="auto" w={{ sm: "100%", md: "unset" }}>
          <AdminNavbarLinks
            onOpen={props.onOpen}
            logoText={props.logoText}
            secondary={props.secondary}
            fixed={props.fixed}
          />
        </Box>
      </Flex>
    </Flex>
  );
}

AdminNavbar.propTypes = {
  brandText: PropTypes.string,
  variant: PropTypes.string,
  secondary: PropTypes.bool,
  fixed: PropTypes.bool,
  onOpen: PropTypes.func,
};
